export const DEFAULT_ANIMATION_DURATION = 0.3;
export const DEFAULT_ANIMATION_TYPE = 'easeIn';
